export const pvcShutter = {
  overview: {
    titles: [
      "Tiết kiệm",
      "Duy trì kiểu dáng đẹp mắt",
      "Chống ẩm",
      "Gia cố để làm cho chúng mạnh mẽ",
    ],
    contents: [
      "Nếu ngân sách của bạn có giới hạn, bạn vẫn có thể thưởng thức tính linh hoạt và vẻ đẹp khó cưỡng của cửa chớp nhờ Cửa Chớp Nhựa PVC. Đây là loại cửa chớp có giá cả mềm nhất nhưng vẫn đảm bảo những tính năng cần thiết của một cửa chớp và kiểu dáng đẹp mắt. Tại Rèm cửa Huy Hoàng, chúng tôi sẽ báo giá miễn phí cho bạn trong lần đầu tiên đến đo đạc và tư vấn cửa chớp cho nhà bạn.",
      "Cửa Chớp Nhựa PVC sẽ không bị nứt, bong tróc, phai màu hay mai một như gỗ. Những thành phẩm cửa chớp hoàn hảo của chúng tôi có khả năng chống lõm và trầy xước nên chúng không cần bạn phải chà nhám, nhuộm màu hay sơn lại.",
      "Hợp chất Polysatin của Cửa Chớp Nhựa PVC của chúng tôi được thiết kế đặc biệt để chống lại điều kiện môi trường ẩm thấp và ẩm ướt.",
      "Cửa chớp PVC của chúng tôi được thiết kế riêng biệt để làm cho chúng thật chắc chắn. Chúng được gia cố tại các điểm chịu lực chính bằng thanh giằng nhôm và khối nhựa resin bên trong để tăng thêm tính bền bỉ và ổn định.",
    ],
  },
  description: {
    titles: ["", ""],
    contents: ["", ""],
  },
};
